import { render, staticRenderFns } from "./PushTextVariantInput.vue?vue&type=template&id=92774a68&scoped=true&"
import script from "./PushTextVariantInput.vue?vue&type=script&lang=js&"
export * from "./PushTextVariantInput.vue?vue&type=script&lang=js&"
import style0 from "./PushTextVariantInput.vue?vue&type=style&index=0&id=92774a68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92774a68",
  null
  
)

export default component.exports